import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import type { ItemMultiLinkValue } from '@/lib/api/types/items';

export const MultiLinkCell = ({ value }: { value?: ItemMultiLinkValue[] }) => {
  if (!value?.length) return null;

  const labels = value.map((entry) => entry.description || entry.MULTI_LINK);

  return (
    <OverflowTooltip
      tooltipContent={<span className="whitespace-pre-wrap">{labels.join('\n')}</span>}
      className="text-text-link hover:text-text-link-hovered"
    >
      {value.map((entry, index) => (
        <span key={entry.id}>
          {index > 0 && ', '}
          <a
            href={entry.MULTI_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            {entry.description || entry.MULTI_LINK}
          </a>
        </span>
      ))}
    </OverflowTooltip>
  );
};
